<template>
	<div class="pga-tournament-pool-manage-entry-page">
		<div class="pga-tournament-pool-manage-entry-page__content" v-if="pool != null && entry != null">
			<div class="wrapper">
				<router-link class="header" :to="{ name: 'pga-tournament-pools', params: { poolId: pool.id } }">
					<span class="material-icons">arrow_back_ios</span>
					{{ pool.name }}
				</router-link>
				<p class="instructions">Choose one player in each tier and enter the winning score to par for the tiebreaker.</p>
				<button class="save-button" @click="saveEntry" :disabled="numberOfPicksMade < poolTierList.length || (tiebreak === null || tiebreak === '')">Save</button>

				<div class="tier-table-header">
					<button @click="tierBack" :disabled="tableToShow == 1">
						<span class="material-icons">arrow_back_ios</span>
					</button>
					<p v-if="tableToShow < poolTierList.length + 1">{{ "Tier " + tableToShow }}</p>
					<p v-if="tableToShow == poolTierList.length + 1">Tiebreak</p>
					<button @click="tierForward" :disabled="tableToShow == poolTierList.length + 1">
						<span class="material-icons">arrow_forward_ios</span>
					</button>
				</div>
				<div class="tiers-wrapper">
					<div class="tiers">
						<div v-for="(tier, index) in poolTierList" :key="tier.id" class="tier-wrapper">
							<div v-if="tier.tier == tableToShow">
								<div class="tier">
									<div class="tier__label-row">
										<p class="tier__label-row--world-rank-label">World Rank</p>
										<p class="tier__label-row--name-label">Player</p>
									</div>
									<div class="tier__player-row" v-for="player in poolTierList[index].pga_tournament_players" :key="player.id" :class="{ active: tierSelections[index][0] == player.id }" @click="playerClicked(player.id, index)">
										<p class="tier__player-row--world-rank" v-if="player.pga_player.world_rank != 999999">{{ player.pga_player.world_rank }}</p>
										<p class="tier__player-row--world-rank" v-else>-</p>
										<p class="tier__player-row--name">{{ player.pga_player.first_name }} {{ player.pga_player.last_name }}</p>
										<input type="checkbox" :true-value="player.id" :false-value="null" v-model="tierSelections[index][0]" :disabled="tierSelections[index][0] != null && tierSelections[index][0] != player.id">
									</div>
								</div>
							</div>
						</div>

						<div class="tiebreak-wrapper" v-if="tableToShow == poolTierList.length + 1">
							<div class="tiebreak">
								<label for="tiebreak">Winning Score To Par (i.e., -8)</label>
								<input id="tiebreak" name="tiebreak" type="number" v-model="tiebreak">
							</div>
						</div>
					
					</div>
				</div>
			</div>
			
		</div>

		<div class="popup" v-if="showSaveSuccessfull">
			<div class="popup__content">
				<p class="font-size--medium">Entry Saved Successfully!</p>
				<div class="popup__content--bottom">
					<button class="font-size--medium text-color--secondary" @click="showSaveSuccessfull = false">Close</button>
				</div>	
			</div>
		</div>
	</div>
</template>

<script>
	import axios from '@/axios'
	import { mapMutations } from 'vuex'

	export default {
		props: [ 'poolId', 'entryId' ],
		data() {
			return {
				pool: null,
				entry: null,
				poolTierList: null,
				tierSelections: [],
				tiebreak: null,
				tableToShow: 1,
				showSaveSuccessfull: false
			}
		},
		computed: {
			alreadySelected() {
				var result  = []
				
				return result
			},
			selections() {
				var selections = []
				this.entry.selections.forEach(function(element) {
					var selection = {
						tier: element.tier,
						pga_tournament_player: element.pga_tournament_player.id
					}
					selections.push(selection)
				})
				return selections
			},
			numberOfPicksMade() {
				var selectionsMade = 0
				this.tierSelections.forEach(element => {
					if (element[0] != null) {
						selectionsMade++
					}
				})
				return selectionsMade
			}
		},
		methods: {
			...mapMutations([
				'HTTP_IN_PROGRESS',
				'HTTP_FINISHED'
			]),
			playerClicked(playerId, index) {
				
				if (this.tierSelections[index] == playerId) {
					this.tierSelections.splice(index, 1, [null])
				} else {
					this.tierSelections.splice(index, 1, [playerId])
				}
				
			},
			tierForward() {
				this.tableToShow++
			},
			tierBack() {
				this.tableToShow--
			},
			saveEntry() {
				this.HTTP_IN_PROGRESS()
				var selections = []
				this.tierSelections.forEach((element, index) => {
					selections.push({
						tier: index + 1,
						pga_tournament_player: {
							id: element[0]
						}
					})
				})
				
				var data = {
					score_to_par_tiebreak: this.tiebreak,
					selections: selections
				}

				axios.patch('pga-tournament-pools/' + this.poolId + '/pga-tournament-pool-entries/' + this.entryId, data).then(response => {
					this.entry = response.data.data
					this.setSelections()
					this.showSaveSuccessfull = true
					this.tableToShow = 1
					this.HTTP_FINISHED()
				})
			},
			getPool() {
				return axios.get('pga-tournament-pools/' + this.poolId)
			},
			setSelections() {
				this.poolTierList.forEach((element) => {
					this.tierSelections[element.tier - 1] = [null]
				})
				this.tiebreak = this.entry.score_to_par_tiebreak
				this.entry.selections.forEach((element) => {
					this.tierSelections.splice(element.tier - 1, 1, [element.pga_tournament_player.id])
				})
			},
			getEntry() {
				this.HTTP_IN_PROGRESS()
				axios.get('pga-tournament-pools/' + this.poolId + '/pga-tournament-pool-entries/' + this.entryId).then(response => {
					this.entry = response.data.data
					this.setSelections()
					this.HTTP_FINISHED()
				}).catch(() => {
					this.$router.replace('/')
				})
			},
			getTierList() {
				this.HTTP_IN_PROGRESS()
				return axios.get('pga-tournaments/' + this.pool.pga_tournament.id + '/pga-tournament-pool-tier-list')
			}
		},
		created() {
			this.HTTP_IN_PROGRESS()
			this.getPool().then(response => {
				this.pool = response.data.data
				this.getTierList().then(response => {
					this.poolTierList = response.data.data
					this.getEntry()
				})
			}).catch(() => {
				this.HTTP_FINISHED()
				//this.$router.replace('/')
			})
		}
	}
</script>

<style lang="scss">
	@import '@/styles/app';
	@import '../../../styles/views/pga/pga-tournament-pool/manageEntry';
</style>